import React, { useState } from "react";
import { LiveClassIcon } from "../common/icons/icons";
import { convertTimestampToDate } from "../common/ults/dateTime";
import { useTranslation } from "react-i18next";
import { useHandleViewBigBlueButton } from "../hooks/useBigBlueButton";
import { domParser } from "../common/ults/domParser";

const fakeRecordings = [
  {
    name: "Buổi học 1",
    startTime: Math.floor(Date.now() / 1000) - 7200,
    length: 3600,
    playback: { format: { url: "#" } },
  },
  {
    name: "Buổi học 2",
    startTime: Math.floor(Date.now() / 1000) - 14400,
    length: 5400,
    playback: { format: { url: "#" } },
  },
];

const LiveClassModal = ({
  bigBlueButtonActivity,
  isOpen,
  onClose,
  courseDetails,
}: any) => {
  const [activeTab, setActiveTab] = useState<"info" | "recordings">("info");
  const recordings = fakeRecordings;
  const isLoading = false;
  const { t } = useTranslation();

  const { viewBigBlueButton } = useHandleViewBigBlueButton();
  const getStatusBadge = () => {
    const status = bigBlueButtonActivity?.status?.value;
    let badge = null;
    switch (status) {
      case "in_progress":
        badge = (
          <>
            <span className="badge bg-success me-1">
              <i className="isax isax-video me-1" />
              {t(`liveClasses.card.status.${status}`)}
            </span>
            {bigBlueButtonActivity?.status?.started_at !== 0 && (
              <span className="badge bg-success mt-1">
                <i className="isax isax-video me-1" />
                {convertTimestampToDate(
                  bigBlueButtonActivity?.status?.started_at
                )}
              </span>
            )}
          </>
        );
        break;
      case "waiting_for_moderator":
        badge = (
          <span className="badge bg-warning">
            <i className="isax isax-clock me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      case "room_ready":
        badge = (
          <span className="badge bg-primary">
            <i className="isax isax-tick-circle me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      case "ended":
        badge = (
          <span className="badge bg-secondary">
            <i className="isax isax-close-circle me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      case "not_started":
        badge = (
          <span className="badge bg-info">
            <i className="isax isax-timer me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      default:
        badge = null;
        break;
    }
    return badge;
  };

  const handleJoinClass = () => {
    if (bigBlueButtonActivity?.join_url) {
      window.open(bigBlueButtonActivity.join_url, "_blank");
      viewBigBlueButton(bigBlueButtonActivity.id);
    }
  };

  return (
    <>
      <div className="modal show d-block" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <LiveClassIcon className="text-danger fs-24 me-2" />
                <div>
                  <h5 className="modal-title mb-0">
                    {bigBlueButtonActivity.name}
                  </h5>
                  <small className="text-muted">
                    {courseDetails?.courses[0]?.fullname}
                  </small>
                  <div className="mt-1">{getStatusBadge()}</div>
                </div>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={onClose}
                aria-label="Close"
              >
                <i className="isax isax-close-circle5" />
              </button>
            </div>
            <div className="modal-body">
              {/* Navigation Tabs */}
              <ul className="nav nav-tabs mb-4" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "info" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("info")}
                    type="button"
                  >
                    <i className="isax isax-info-circle me-2" />
                    {t("liveClasses.modal.tabs.info")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "recordings" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("recordings")}
                    type="button"
                  >
                    <i className="isax isax-video-play me-2" />
                    {t("liveClasses.modal.tabs.recordings")}
                  </button>
                </li>
              </ul>
              {/* Tab Content */}
              <div className="tab-content">
                {/* Info Tab */}
                {activeTab === "info" && (
                  <div className="tab-pane fade show active">
                    {isLoading ? (
                      <div className="text-center py-4">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Đang tải...</span>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-lg-12">
                            {/* Meeting Description */}
                            {bigBlueButtonActivity.intro && (
                              <div className="card mb-4">
                                <div className="card-body">
                                  <h6 className="card-title">
                                    {t("liveClasses.modal.details.description")}
                                  </h6>
                                  <p
                                    className="card-text"
                                    dangerouslySetInnerHTML={{
                                      __html: domParser(
                                        bigBlueButtonActivity?.intro || ""
                                      ),
                                    }}
                                  ></p>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="col-lg-12">
                            {/* Meeting Details */}
                            <div className="card">
                              <div className="card-body">
                                <h6 className="card-title">
                                  {t("liveClasses.modal.details.title")}
                                </h6>
                                <div className="d-flex gap-2">
                                  <p>
                                    {bigBlueButtonActivity.moderator_count}{" "}
                                    {t("liveClasses.modal.details.moderator")}
                                  </p>
                                  <p>
                                    {bigBlueButtonActivity.viewer_count}{" "}
                                    {t("liveClasses.modal.details.viewer")}
                                  </p>
                                </div>
                                {/* Status Message */}
                                <div className="mb-3">
                                  <small className="text-muted">
                                    {t("liveClasses.modal.details.status")}
                                  </small>
                                  <div
                                    className={`fw-bold ${
                                      bigBlueButtonActivity.status.value.includes(
                                        "in_progress"
                                      )
                                        ? "text-success"
                                        : bigBlueButtonActivity.status.value.includes(
                                            "waiting_for_moderator"
                                          )
                                        ? "text-warning"
                                        : bigBlueButtonActivity.status.value.includes(
                                            "ended"
                                          )
                                        ? "text-secondary"
                                        : "text-info"
                                    }`}
                                  >
                                    {t(
                                      `liveClasses.card.status.${bigBlueButtonActivity.status.value}`
                                    )}
                                  </div>
                                </div>
                                {/* Join Button */}
                                <div className="d-grid mt-4">
                                  <button
                                    className="btn btn-success btn-lg"
                                    disabled={
                                      !bigBlueButtonActivity.status.value.includes(
                                        "in_progress"
                                      )
                                    }
                                    onClick={handleJoinClass}
                                  >
                                    <i className="isax isax-video me-2" />
                                    {t("liveClasses.modal.buttons.joinClass")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {/* Recordings Tab */}
                {activeTab === "recordings" && (
                  <div className="tab-pane fade show active">
                    {bigBlueButtonActivity?.recordings &&
                    Array.isArray(recordings) &&
                    recordings.length > 0 ? (
                      <div className="row">
                        {bigBlueButtonActivity?.recordings.map(
                          (recording: any, index: number) => (
                            <div key={index} className="col-md-6 mb-3">
                              <div className="card">
                                <div className="card-body">
                                  <h6 className="card-title">
                                    {recording.name}
                                  </h6>
                                  <p className="card-text">
                                    <small className="text-muted">
                                      {t(
                                        "liveClasses.modal.recordings.recordedAt"
                                      )}{" "}
                                      {convertTimestampToDate(
                                        recording.created_at
                                      )}
                                    </small>
                                  </p>
                                  <div className="action-btns d-flex gap-4">
                                  {recording?.url && (
                                    <div className="d-flex gap-2">
                                      <a
                                        href={recording.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary btn-sm"
                                      >
                                        <i className="isax isax-play me-2" />
                                        {t(
                                          "liveClasses.modal.buttons.playback"
                                        )}
                                      </a>
                                    </div>
                                  )}
                                  {recording?.video && (
                                    <div className="d-flex gap-2">
                                      <a
                                        href={recording.video}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary btn-sm"
                                      >
                                        <i className="isax isax-play me-2" />
                                        {t(
                                          "liveClasses.modal.buttons.watchVideo"
                                        )}
                                      </a>
                                    </div>
                                  )}
                                   {recording?.podcast && (
                                     <div className="d-flex gap-2">
                                       <a
                                         href={recording.podcast}
                                         target="_blank"
                                         rel="noopener noreferrer"
                                         className="btn btn-outline-primary btn-sm"
                                       >
                                         <i className="isax isax-play me-2" />
                                         {t("liveClasses.modal.buttons.podcast")}
                                       </a>
                                     </div>
                                   )}
                                   </div>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <i className="isax isax-video-slash fs-48 text-muted mb-3 d-block" />
                        <h6 className="text-muted">Không có ghi hình</h6>
                        <p className="text-muted">
                          Chưa có buổi học nào được ghi hình.
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop show"></div>
      </div>
    </>
  );
};

export default LiveClassModal;
